import { Component, inject } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingComponent } from '../../loading/loading.component';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BookableEvent } from '../../lib/events';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-event-selection',
  imports: [LoadingComponent, DatePipe],
  templateUrl: './event-selection.component.html',
})
export class EventSelectionComponent {
  public readonly apiService = inject(ApiService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  
  public bookableEvents = toSignal(this.apiService.fetchBookableEvents(), {
    initialValue: [],
  });

  /**
   * Handle event selection - store event and navigate to booking or auth
   * If user is already authenticated, skip auth selection and go directly to booking
   */
  selectEvent(event: BookableEvent): void {
    // Store selected event in sessionStorage
    sessionStorage.setItem('selectedEventSlug', event.slug);
    sessionStorage.setItem('selectedEventTitle', event.title);
    
    // Check bookingMode first (synchronous check)
    const bookingMode = sessionStorage.getItem('bookingMode');
    
    if (bookingMode === 'authenticated') {
      // User claims to be authenticated → verify with backend before navigating
      this.authService.checkUserLoggedIn().subscribe({
        next: (response) => {
          if (response.logged_in && response.user) {
            // User is verified → go directly to booking
            this.router.navigate(['/booking', event.slug]);
          } else {
            // User session expired → clear auth and go to auth selection
            this.authService.logout();
            this.router.navigate(['/auth']);
          }
        },
        error: () => {
          // Backend check failed → clear auth and go to auth selection
          this.authService.logout();
          this.router.navigate(['/auth']);
        }
      });
    } else {
      // User is not authenticated → show auth selection (Login/Register/Guest)
      this.router.navigate(['/auth']);
    }
  }

  /**
   * Get the image filename for a festival
   * Falls back to loge-placeholder.png if specific title image doesn't exist
   */
  getTitleImagePath(slug: string): string {
    // Try specific title image first, with fallback to placeholder
    return `/titel-${slug}.png`;
  }

  /**
   * Handle image load error and fall back to placeholder
   */
  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = '/loge-placeholder.png';
  }
}
